const $editorialController = $('#main-collection-filters');
const $editorialView = $("#editorialController");

$editorialView.on("input", function() {
    $editorialController.toggleClass('editorial-view-list');
});